import React from 'react';
import { Link } from 'react-router-dom';
import { NameStory } from '../components/home/NameStory';
import { TasteMap } from '../components/home/TasteMap';
import { Mission } from '../components/home/Mission';
import { Reveal } from '../components/Reveal';
import { ArrowMark } from '../components/Marks';
const DOORS = [{
  to: '/catering',
  label: 'Beställ catering'
}, {
  to: '/guide',
  label: 'Läs guiden'
}, {
  to: '/butik',
  label: 'Handla i butiken'
}];
export function About() {
  return <div data-id="element-761" data-mp="377nka5spriyg">
      <NameStory data-id="element-762" data-mp="376cj8dqnkpb1" />
      <TasteMap data-id="element-763" data-mp="376vpuyaurr9r" />
      <Mission data-id="element-764" data-mp="375b4nzafhkok" />

      <section aria-labelledby="vidare" className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-765" data-mp="2sa4zfej5ppwa">
        <Reveal data-id="element-766" data-mp="2x97r7xa4lzmb">
          <h2 id="vidare" className="display-xl text-3xl uppercase sm:text-4xl" data-id="element-767" data-mp="2x8okzdtu8zo4">
            Nu vet du hur vi tänker
          </h2>
          <div className="mt-8 flex flex-wrap gap-4" data-id="element-768" data-mp="1gu6m2ygy4hp9">
            {DOORS.map(door => <Link key={door.to} to={door.to} className="group flex items-center gap-3 border-2 border-black px-7 py-4 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out hover:bg-black hover:text-papper" data-id="element-769" data-mp="1lv4337q7z5p6">
                {door.label}
                <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-770" data-mp="23gdksqn23u8y" />
              </Link>)}
          </div>
        </Reveal>
      </section>
    </div>;
}